import { render, staticRenderFns } from "./FreeTrip.vue?vue&type=template&id=141a6079&scoped=true"
import script from "./FreeTrip.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeTrip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FreeTrip.vue?vue&type=style&index=0&id=141a6079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a6079",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner});
